// @ts-nocheck
export default function PressMarquee() {
  return (
    <>
<div className="press">
  {/* Was "Citation-verified courts & tribunals" naming the UK Supreme Court,
      Court of Appeal, High Court, CJEU… — the adapters verify statutes and
      provisions, never case law, and legal research is India-only here.
      2026-10-08: the nine statute registers it then listed check LexVio's
      own jurisdiction notes before publication; no customer answer has
      passed through them yet, so the strip now names the fourteen laws of
      the global privacy programme (g-backend app/services/privacy_packs). */}
  <div className="press-lbl">Privacy &amp; Data Protection · fourteen laws, one engine</div>
  <div className="press-logos">
    <span className="pl">EU GDPR</span><span className="pl">UK GDPR</span><span className="pl">CCPA / CPRA</span><span className="pl">NY SHIELD</span><span className="pl">Delaware PDPA</span>
    <span className="pl">PIPEDA</span><span className="pl">Privacy Act (Australia)</span><span className="pl">Privacy Act 2020 (NZ)</span><span className="pl">PDPA (Singapore)</span><span className="pl">PDPO (Hong Kong)</span><span className="pl">POPIA</span><span className="pl">Kenya DPA</span><span className="pl">Nigeria NDPA</span><span className="pl">DIFC DPL</span>
  </div>
</div>
<div className="mband"><div className="mtrack" id="mtrack"></div></div>

    </>
  );
}
